<template>
  <div :class="{ 'p-3': isStandardV2 && !isVisionVenture }">
    <!-- Standard V2 branch: ครอบด้วย StandardV2Layout ในหน้า -->
    <template v-if="isVisionVenture">
      <VisionVentureHome v-if="!isLoading" />
      <div
        v-show="isLoading"
        class="profile-skeleton"
        data-test="profile-loading"
        aria-hidden="true"
      >
        <div class="profile-skeleton__top">
          <span class="profile-skeleton__avatar"></span>
          <span
            class="profile-skeleton__line profile-skeleton__line--name"
          ></span>
          <span
            class="profile-skeleton__line profile-skeleton__line--logo"
          ></span>
        </div>
        <div class="profile-skeleton__hero">
          <span
            class="profile-skeleton__line profile-skeleton__line--wide"
          ></span>
          <span
            class="profile-skeleton__line profile-skeleton__line--short"
          ></span>
        </div>
      </div>
    </template>
    <StandardV2Layout v-else-if="isStandardV2" :isLoading="isLoading">
      <StandardV2Home v-if="!isLoading" />
      <div
        v-show="isLoading"
        class="profile-skeleton"
        data-test="profile-loading"
        aria-hidden="true"
      >
        <div class="profile-skeleton__top">
          <span class="profile-skeleton__avatar"></span>
          <span
            class="profile-skeleton__line profile-skeleton__line--name"
          ></span>
          <span
            class="profile-skeleton__line profile-skeleton__line--logo"
          ></span>
        </div>
        <div class="profile-skeleton__hero">
          <span
            class="profile-skeleton__line profile-skeleton__line--wide"
          ></span>
          <span
            class="profile-skeleton__line profile-skeleton__line--short"
          ></span>
        </div>
        <div class="profile-skeleton__summary">
          <span></span>
          <span></span>
        </div>
        <div class="profile-skeleton__list">
          <span></span>
          <span></span>
        </div>
      </div>
    </StandardV2Layout>

    <!--
      Vision Venture branch: VisionVentureLayout ครอบจาก App.vue แล้ว
      ห้าม wrap ด้วย StandardV2Layout ที่นี่ ไม่งั้น bottom nav จะซ้อน 2 อัน
    -->

    <!-- Legacy layouts -->
    <template v-else-if="!isLoading">
      <div class="content-page" data-test="profile-page">
        <LayoutNewDesign v-if="layoutDisplay == 'Compact'" />
        <LayoutMinimal
          v-else-if="
            layoutDisplay == 'Minimal' ||
            $isMinimalProfile ||
            $isMinimalProfileBanner
          "
        />
        <LayoutClean v-else-if="$isCleanLayout" />
        <Layout v-else :profile="profile" />
      </div>
    </template>

    <ModalRegisterAlert
      ref="ModalRegisterAlert"
      data-test="profile-register-alert-modal"
    />
  </div>
</template>

<script>
import { Layout, LayoutNewDesign, LayoutMinimal, LayoutClean } from "./Layout";
import ModalRegisterAlert from "@/components/profile/modal/ModalRegisterAlert";
import { useDialog } from "@/services/dialogService";
import CustomFormPromptDialogContent from "@/components/dialog-content/CustomFormPromptDialogContent.vue";
import UploadFile from "@/components/custom-fields/fields/UploadFile";
import StandardV2Home from "./StandardV2Home.vue";
import VisionVentureHome from "./VisionVentureHome.vue";
import StandardV2Layout from "@/views/layout/StandardV2Layout.vue";
import { isPreviewMode } from "@/utils/previewMode";
export default {
  components: {
    StandardV2Home,
    VisionVentureHome,
    StandardV2Layout,
    Layout,
    LayoutNewDesign,
    LayoutMinimal,
    ModalRegisterAlert,
    UploadFile,
    LayoutClean
  },
  setup() {
    const dialog = useDialog();
    return { dialog };
  },
  async created() {
    this.profile = await this.getProfile();
    this.getCustomObject();
    this.isLoading = false;
  },
  mounted() {
    if (isPreviewMode()) return;
    this.$refs.ModalRegisterAlert.show();
  },
  data() {
    return {
      layoutDisplay: this.lineLayout,
      isLoading: true,
      profile: {}
    };
  },
  computed: {
    isStandardV2() {
      return this.$isStandardV2 || this.lineLayout === "standard-v2";
    },
    isVisionVenture() {
      return (
        this.$isVisionVenture || this.lineLayout === "vision-venture-theme"
      );
    },
    useStandardV2Layout() {
      return this.isStandardV2 || this.isVisionVenture;
    }
    // useStandardV2Layout เก็บไว้เผื่อโค้ดอื่นอ้างถึง — แต่ template แยก branch แล้ว
  },
  methods: {
    async getProfile() {
      return new Promise(async resolve => {
        const res = await this.$store.dispatch("getUserProfile", true);
        return resolve(res);
      });
    },
    async getCustomObject() {
      try {
        const data = await this.$axios(
          `/api/CustomObject/custom_object_register_page`
        );
        let id = this.$cookies.get("modalShowId") || [];
        const formList = data.detail.filter(el => !id.includes(el.id));

        for (let i = 0; i < formList.length; i++) {
          const banner = formList[i];
          const result = await this.dialog.showCustom(
            CustomFormPromptDialogContent,
            {
              data: banner,
              index: i
            }
          );
          if (result?.action !== "addAnswer") {
            let cid = this.$cookies.get("modalShowId") || [];
            this.$cookies.set("modalShowId", [...cid, banner.id]);
          }
          if (result?.action === "addAnswer") break;
        }
      } catch (err) {
        this.$logger({
          response: err?.response || {
            config: err?.config || {
              url: "/api/CustomObject/custom_object_register_page",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getCustomObject API request failed" }
        });
        console.log("getCustomObject", err.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-skeleton {
  // padding: 16px;
}

.profile-skeleton__top,
.profile-skeleton__summary {
  display: flex;
  align-items: center;
  gap: 10px;
}

.profile-skeleton__top {
  margin-bottom: 14px;
}

.profile-skeleton__avatar,
.profile-skeleton__line,
.profile-skeleton__hero,
.profile-skeleton__summary span,
.profile-skeleton__list span {
  position: relative;
  overflow: hidden;
  background: #eeeeee;
}

.profile-skeleton__avatar::after,
.profile-skeleton__line::after,
.profile-skeleton__hero::after,
.profile-skeleton__summary span::after,
.profile-skeleton__list span::after {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.6),
    transparent
  );
  content: "";
  transform: translateX(-100%);
  animation: profile-skeleton-shimmer 1.2s infinite;
}

.profile-skeleton__avatar {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border-radius: 50%;
}

.profile-skeleton__line {
  display: block;
  height: 12px;
  border-radius: 999px;
}

.profile-skeleton__line--name {
  width: 42%;
}

.profile-skeleton__line--logo {
  width: 72px;
  margin-left: auto;
}

.profile-skeleton__line--wide {
  width: 56%;
  margin: 22px 0 10px 16px;
}

.profile-skeleton__line--short {
  width: 34%;
  margin-left: 16px;
}

.profile-skeleton__hero {
  height: 154px;
  margin-bottom: 14px;
  border-radius: 16px;
}

.profile-skeleton__summary {
  margin-bottom: 14px;
}

.profile-skeleton__summary span {
  flex: 1;
  height: 58px;
  border-radius: 16px;
}

.profile-skeleton__list {
  display: grid;
  gap: 10px;
}

.profile-skeleton__list span {
  height: 86px;
  border-radius: 12px;
}

@keyframes profile-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
